import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import useReveal from '@/hooks/useReveal';
import SchemaJsonLd from '@/seo/SchemaJsonLd';
import Hero from './components/Hero';
import About from './components/About';
import Strengths from './components/Strengths';
import Services from './components/Services';
import Process from './components/Process';
import Testimonials from './components/Testimonials';
import Contact from './components/Contact';

export default function Home() {
  useReveal();

  return (
    <div className="w-full min-h-screen bg-background-50">
      <SchemaJsonLd />
      <Navbar />
      <main>
        <Hero />
        <About />
        <Strengths />
        <Services />
        <Process />
        <Testimonials />
        <Contact />
      </main>
      <Footer />
    </div>
  );
}